import Point from "ol/geom/Point";
import PointFeature from "./PointFeature";
import { TrackEntity } from "./TrackEntity";
import TrackLineFeature from "./TrackLineFeature";

export default class TrackPointFeature extends PointFeature {
    trackLineFeature: TrackLineFeature
    indexWithinFeature: number
    anchorIndex: number|null //the anchor this trackpoint is 'tied' to, if any
    constructor(geometryOrProperties: Point, track: TrackEntity, order: number, trackLineFeature: TrackLineFeature, indexWithinFeature: number, anchorIndex: number|null) {
        super(geometryOrProperties, track, order)
        this.trackLineFeature = trackLineFeature
        this.indexWithinFeature = indexWithinFeature
        this.anchorIndex = anchorIndex
    }
    getGeometry(): Point {
        return super.getGeometry()!
    }
}